module.exports = __webpack_public_path__ + "static/media/panopto-logo.538da5af.png";